var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M32.5 46.267a4.347 4.347 0 1 0 0-8.694 4.347 4.347 0 0 0 0 8.694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M44.9 25.174H19.487V22.08c0-7.813 2.213-13.013 13.013-13.013 11.547 0 13.014 5.627 13.014 10.533 0 1.04.826 1.867 1.866 1.867s1.867-.827 1.867-1.867c0-9.467-5.627-14.266-16.747-14.266-15.013 0-16.746 9.546-16.746 16.746v3.334c-7.467.933-9.92 4.72-9.92 14.026v4.96c0 10.934 3.333 14.267 14.266 14.267h24.8c10.934 0 14.267-3.334 14.267-14.267v-4.96c0-10.933-3.334-14.266-14.267-14.266m-12.4 24.8c-4.453 0-8.053-3.627-8.053-8.054 0-4.453 3.627-8.053 8.053-8.053s8.054 3.627 8.054 8.053c0 4.453-3.6 8.054-8.054 8.054"
  })));
};
export default SvgUnlock;